import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { FilterAltOffRounded, SearchOffRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoTemplatesFound = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.emailTemplates.notFound.primary')}
            secondary={t('prompts:noData.emailTemplates.notFound.secondary')}
            Icon={SearchOffRounded}
            action={
                <Button
                    variant="tonal"
                    color="secondary"
                    startIcon={<FilterAltOffRounded />}
                    LinkComponent={Link}
                    to="."
                >
                    {t('Clear Filters')}
                </Button>
            }
        />
    );
};

export default NoTemplatesFound;
